export const halfPageFormCSS = () => ({
  width: '50%',
})

export const quarterPageFormCSS = () => ({
  width: '25%',
})
